import { THEME_COLORS } from '@/theme/colors.ts';
import {
  createTheme,
  DEFAULT_THEME,
  mergeMantineTheme,
  Textarea,
  TextInput
} from '@inexture/core';

const themeOverride = createTheme({
  colors: THEME_COLORS,
  primaryColor: 'primary',
  fontFamily: 'var(--base-font)',
  primaryShade: 8,
  defaultRadius: 'sm',
  components: {
    TextInput: TextInput.extend({
      styles: () => ({
        input: {
          color: '#666666',
          fontSize: '14px'
        }
      })
    }),
    Textarea: Textarea.extend({
      styles: () => ({
        input: {
          color: '#666666',
          fontSize: '14px'
        }
      })
    })
  }
});

export const theme = mergeMantineTheme(DEFAULT_THEME, themeOverride);
